(function ($) {

  var num = function (value) {
    return parseInt(value, 10) || 0;
  };

  $.fn.cssAsInteger = function (property) {
    return num(this.css(property));
  };


}(jQuery));

define("lib/jquery/jquery.cssAsInteger", ["jquery"], function(){});

